(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.not-found-content', ['pp.widgets-templates']);

ngModule.component('ppNotFoundContent', {
    templateUrl: 'widgets/_angular/not-found-content/not-found-content.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);